const messageStyle = {
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: '#35B446',
  color: '#ffffff',
  textAlign: 'center',
  zIndex: 2000,
  height: '32px',
  paddingTop: '5px'
};

export default function Notification({children}) {
  return (<div id="notification" style={messageStyle}>
    {children}
  </div>);
}